import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';


// Imports Application
import { DContextoMuisca } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DBasicosParametricasServicios } from '@dian/api-basicos-parametricas';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DObserverTimerSessionApp } from './configuracion/dformulario-configuracion';
import { ItemMenu } from './components/item-menu/item-menu.component';
import { MessageObservableService } from './services/message-observable.service';
import { environment } from '../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

const optionsMenuLeft: ItemMenu[] = [
	{
		iconActive: './assets/img/svg/nuevos/b-inicio.png',
		iconInactive: './assets/img/svg/nuevos/inicio3.png',
		text: 'Inicio',
		link: '/#/ingreso',
		isActive: false,
		esMuisca: false
	},
	{
		iconActive: './assets/img/svg/nuevos/crear-white.svg',
		iconInactive: './assets/img/svg/nuevos/crear.svg',
		text: 'Haga su declaración de renta',
		link: '/#/ingreso/crearFormulario',
		isActive: true,
		esMuisca: false
	},
	{
		iconActive: './assets/img/svg/nuevos/agregar-fecha-white.png',
		iconInactive: './assets/img/svg/nuevos/agregar-fecha.png',
		text: 'Edite su declaración de renta',
		link: '/#/ingreso/borradores',
		isActive: false,
		esMuisca: false
	},
	{
		iconActive: './assets/img/svg/nuevos/tareas-white.png',
		iconInactive: './assets/img/svg/nuevos/tareas.svg',
		text: 'Presente declaración de renta por fracción de año',
		link: '/#/ingreso/fraccion',
		isActive: false,
		esMuisca: false
	},
	{
		iconActive: './assets/img/svg/nuevos/presentados-white.png',
		iconInactive: './assets/img/svg/nuevos/presentados.png',
		text: 'Formularios definitivos listos para presentación',
		link: '/#/ingreso/definitivos',
		isActive: false,
		esMuisca: false
	},
	{
		iconActive: './assets/img/svg/nuevos/pago-cuotas-white.png',
		iconInactive: './assets/img/svg/nuevos/pago-cuotas.svg',
		text: 'Declaraciones de rentas presentadas',
		link: '/#/ingreso/presentados',
		isActive: false,
		esMuisca: false
	},
	/*{
		iconActive: './assets/img/png/b-pagos.png',
		iconInactive: './assets/img/png/pagos.png',
		text: 'Pagos por cuotas',
		link: '/#/ingreso/cuotas',
		isActive: false,
		esMuisca: false
	},*/
	{
		iconActive: './assets/img/png/volver-muisca.png',
		iconInactive: './assets/img/png/volver-muisca.png',
		text: 'Regresar a <b>Mis trámites y servicios</b> (Consulte información exógena, Comunicados, Actualización RUT)',
		link: '/WebDashboard/DefDashboard.faces',
		isActive: false,
		esMuisca: true
	}
];


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	providers: [
		DContextoUsuarioServicio,
		DBasicosParametricasServicios,
		DNotificacionServicio
	]
})
export class AppComponent implements OnInit {

	public loading: boolean = false;
	public rutaIngreso: string = environment.urlIngreso;
	public session: DContextoMuisca = new DContextoMuisca();
	public currentDate: Date = new Date();
	public menuLeft: ItemMenu[] = optionsMenuLeft;
	public openedMenu: boolean = false;

	constructor(
		private dialog: MatDialog,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private dContextoUsuarioServicio: DContextoUsuarioServicio,
		private dNotificacionServicio: DNotificacionServicio,
		private _messagesObs: MessageObservableService		
	) { }

	ngOnInit(): void {
		this.loadSessionData();
		this.listenMessagesObs();
		//this.redirectModeUser();		
	}

	/*private redirectModeUser() {
		this.activatedRoute.queryParams.subscribe(params => {
			console.log(params);
			if (params.hasOwnProperty('modo')) {
				if (params.modo === 'experto')
					this.router.navigate(['']);
				else this.router.navigate(['']);
			}
		});
	}*/

	private listenMessagesObs() {
		this._messagesObs.getMessages().subscribe(res => {
			if (res.operation === 'tiene-firma') 
				if (res.message) this.menuLeft.splice(4, 1);
		});
	}	

	private loadSessionData() {
		this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca().subscribe(
			res => {
				this.session = <DContextoMuisca>res;
				let newTime = new Date();
				this.verificarSession();

				setInterval(() => {
					newTime.setSeconds(newTime.getSeconds() + 1);
					this.currentDate = new Date(newTime);
				}, 1000);
			}
		);
	}

	/**
	* @desc Función para enviar un log
	*/
	public enviarLog() {
		let dialogo = {
			height: '450px',
			disableClose: true
		};
		let dialogRef = this.dialog.open(DEnvioLogComponente, dialogo);
		dialogRef.afterClosed().subscribe(result => {
			console.log('Dialog result: ', result);
		});
	}

	/**
	* @desc Función para redireccionar a un link especifico de Muisca
	*/
	public hrefButton(href: string, nuevaPagina?: boolean) {
		if (nuevaPagina) window.open(location.origin + href, '_blank');
		else window.location.href = location.origin + href;
	}

	/**
	* @desc Función para abrir un link especifico de Muisca en otra pestaña
	*/
	public hrefButtonOpen(href: string) {
		window.open(location.origin + href);
	}

	/**
	* @desc Función para hacer el logout de la aplicación
	*/
	public logoutApp() {
		this.dContextoUsuarioServicio.logOut();
		sessionStorage.removeItem('DIAN-MUISCASESSION');
		sessionStorage.removeItem('DIAN-MUISCATK');
		sessionStorage.removeItem('DIAN-MUISCALOG');
	}

	/**
	* @desc Funcion que verifica un observable para validar la session
	*/
	private verificarSession() {
		const observer: DObserverTimerSessionApp = new DObserverTimerSessionApp(this.dNotificacionServicio, this.dContextoUsuarioServicio);
		this.dContextoUsuarioServicio.establecerAccionCierreSesionUsuario(observer).subscribe(
			res => console.log('Accion establecida con cerrar sesión', res),
			error => console.error('Error estableciendo accion de cierre de sesión', error));
	}

	backButton() {		
		window.location.href = window.location.origin + '/WebDilIngresoFormRenta210/#/ingreso?idRequest=c3VnZXJpZGE9MjAyMg%3D%3D';
	}

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/app.component.ts